// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  // Not a security risk for public to see this.
  // apiKey simply identifies the Firebase project on Google servers, but by itself does not allow access to it.
  apiKey: "AIzaSyDgDhcgM4LqRLCxLpy73x7JZBVe4A3X2PI",
  authDomain: "heart-web-app.firebaseapp.com",
  projectId: "heart-web-app",
  storageBucket: "heart-web-app.appspot.com",
  messagingSenderId: "253523559856",
  appId: "1:253523559856:web:b796d270bac9fd3c014275",
  measurementId: "G-Q7V07CC51W"
};

